import type { LogoProps } from '@/types'

import { cn } from '@/lib/utils'

export const Logo = ({ className, variant = 'full', tone = 'ink' }: LogoProps) => {
    const isParchment = tone === 'parchment'

    return (
        <span dir='ltr' lang='sq' className={cn('inline-flex items-center gap-2.5', className)}>
            <span
                className={cn(
                    'grid size-10 shrink-0 place-items-center rounded-[0.72rem] border transition-colors',
                    isParchment
                        ? 'border-parchment/30 bg-parchment/[0.06]'
                        : 'border-navy/15 bg-white'
                )}
            >
                <img
                    src='/brand/germa-icon.png'
                    alt=''
                    className='h-7 w-auto object-contain'
                />
            </span>

            {variant === 'full' && (
                <span className='flex flex-col items-start text-left leading-none'>
                    <span
                        className={cn(
                            'text-[0.6rem] font-semibold uppercase tracking-[0.2em]',
                            isParchment ? 'text-parchment/70' : 'text-muted-foreground'
                        )}
                    >
                        Instituti
                    </span>
                    <span
                        className={cn(
                            'font-display text-lg font-semibold uppercase tracking-wide',
                            isParchment ? 'text-parchment' : 'text-foreground'
                        )}
                    >
                        Germa
                    </span>
                </span>
            )}
        </span>
    )
}
